<script>
var ctms = '/etms/ctms/'
var tms = '/etms/tms/'
var ems = '/etms/ems/'
const menus = [
  {
    menuid: '1',
    parentmenuid:'0',
    menuname: '发货管理',
    path: '',
    icon:'',
    opens:[],
    children: [
      {
        menuid: '1-1',
        parentmenuid:'1',
        menuname: '运单管理',
        path: '',
        icon: 'icon-waybill',
        opens:[],
        children: [
          {
            menuid: '1-1-1',
            parentmenuid:'1-1',
            menuname: '我要发货',
            icon: 'icon-send',
            opens:[],
            path: ctms + 'create_delivery'
          }, {
            menuid: '1-1-2',
            parentmenuid:'1-1',
            menuname: '导入运单',
            icon: 'icon-import',
            opens:[],
            path: ctms + 'import_waybill'
          }, {
            menuid: '1-1-3',
            parentmenuid:'1-1',
            menuname: '我的运单',
            icon: 'icon-myorder',
            opens:[],
            path: ctms + 'my_waybill'
            // }, {
            //   menuid: '1-1-4',
            //   menuname: '面单打印',
            //   icon: 'icon-print',
            //   path: ctms + 'waybill_print'
            // }, {
            // menuid: '1-1-5',
            // menuname: '我的模版',
            // icon: 'icon-template',
            // path: ctms + 'my_template'
          }
        ]
      }, {
        menuid: '1-2',
        parentmenuid:'1',
        menuname: '物流管理',
        path: '',
        icon: 'icon-truck',
        opens:[],
        children: [
          {
            menuid: '1-2-1',
            parentmenuid:'1-2',
            menuname: '发货设置',
            path: ctms + 'deliver_setting',
            opens:[],
            icon: 'icon-delivery'
          }, {
            menuid: '1-2-2',
            parentmenuid:'1-2',
            menuname: '我的地址',
            path: ctms + 'my_address',
            opens:[],
            icon: 'icon-address'
          }
        ]
      }, {
        menuid: '1-3',
        parentmenuid:'1',
        menuname: '账务中心',
        path: '',
        icon: 'icon-financial',
        opens:[],
        children: [
          {
            menuid: '1-3-1',
            parentmenuid:'1-3',
            menuname: '运费明细',
            path: ctms + 'waybill_fee_details',
            opens:[],
            icon: 'icon-feedetails'
          }, {
            menuid: '1-3-2',
            parentmenuid:'1-3',
            menuname: '物流账单',
            path: ctms + 'logistics_bills',
            opens:[],
            icon: 'icon-billing'
          }
        ]
      }
    ]
  }, {
    menuid: '2',
    parentmenuid:'0',
    menuname: '物流工作台',
    path: '',
    opens:[],
    icon:'',
    children: [
      {
        menuid: '2-1',
        parentmenuid:'2',
        menuname: '运单中心',
        icon: 'icon-waybill',
        opens:[],
        path: '',
        opens:[],
        children: [
          {
            menuid: '2-1-1',
            parentmenuid:'2-1',
            menuname: '创建运单',
            path: tms + 'create_waybill',
            opens:[],
            icon: 'icon-install'
          }, {
            menuid: '2-1-2',
            parentmenuid:'2-1',
            menuname: '导入运单',
            path: tms + 'import_waybill',
            opens:[],
            icon: 'icon-import'
          }, {
            menuid: '2-1-3',
            parentmenuid:'2-1',
            menuname: '运单管理',
            path: tms + 'waybill_manage',
            opens:[],
            icon: 'icon-waybill'
          }, {
            menuid: '2-1-4',
            parentmenuid:'2-1',
            menuname: '网点扫件',
            path: tms + 'branch_scan',
            opens:[],
            icon: 'icon-scan'
          }, {
            menuid: '2-1-5',
            parentmenuid:'2-1',
            menuname: '入库处理',
            path: tms + 'inbound_processing',
            opens:[],
            icon: 'icon-storage'
          }, {
            menuid: '2-1-6',
            parentmenuid:'2-1',
            menuname: '出库处理',
            path: tms + 'outbound_processing',
            opens:[],
            icon: 'icon-outbound'
            // }, {
            //   menuid: '2-1-7',
            //   menuname: '面单打印',
            //   path: tms + 'waybill_print',
            //   icon: 'icon-print'
          }, {
            menuid: '2-1-8',
            parentmenuid:'2-1',
            menuname: '工单处理',
            path: tms + 'work_waybill_processing',
            opens:[],
            icon: 'icon-entregister'
          }
        ]
      }, {
        menuid: '2-2',
        parentmenuid:'2',
        menuname: '渠道中心',
        icon: 'icon-channel',
        opens:[],
        path: '',
        children: [
          {
            menuid: '2-2-1',
            parentmenuid:'2-2',
            menuname: '渠道管理',
            icon: 'icon-channel',
            opens:[],
            path: tms + 'channel_manage'
          }, {
            menuid: '2-2-2',
            parentmenuid:'2-2',
            menuname: '线路管理',
            icon: 'icon-lines',
            opens:[],
            path: tms + 'line_manage'
          }, {
            //   menuid: '2-2-3',
            //   menuname: '计费分类',
            //   icon: 'icon-calculate',
            //   path: tms + 'billing_category'
            // }, {
            menuid: '2-2-4',
            parentmenuid:'2-2',
            menuname: '号段管理',
            icon: 'icon-ordernum',
            opens:[],
            path: tms + 'oddnum_manage'
          }, {
            menuid: '2-2-5',
            parentmenuid:'2-2',
            menuname: '抓单对接',
            icon: 'icon-sysdocking',
            opens:[],
            path: tms + 'channel_docking'
          }, {
            menuid: '2-2-6',
            parentmenuid:'2-2',
            menuname: '电商对接',
            icon: 'icon-ecdocking',
            opens:[],
            path: tms + 'ec_docking'
          }, {
            menuid: '2-2-7',
            parentmenuid:'2-2',
            menuname: '价格设置',
            icon: 'icon-price',
            opens:[],
            path: tms + 'channel_price_setting'
          }
        ]
      }, {
        menuid: '2-3',
        parentmenuid:'2',
        menuname: '供应中心',
        icon: 'icon-supplierm',
        opens:[],
        path: '',
        children: [
          {
            menuid: '2-3-1',
            parentmenuid:'2-3',
            menuname: '供应商管理',
            path: tms + 'supplier_manage',
            opens:[],
            icon: 'icon-tmsupplier'
          }, {
            menuid: '2-3-2',
            parentmenuid:'2-3',
            menuname: '供应商折扣',
            icon: 'icon-discount',
            opens:[],
            path: tms + 'supplier_discount_setting'
          }
        ]
      }, {
        menuid: '2-4',
        parentmenuid:'2',
        menuname: '客户中心',
        opens:[],
        icon: 'icon-customer-center',
        path: '',
        children: [
          {
            menuid: '2-4-1',
            parentmenuid:'2-4',
            menuname: '客户管理',
            opens:[],
            path: tms + 'customer_manage',
            icon: 'icon-customer'
          }, {
            menuid: '2-4-2',
            parentmenuid:'2-4',
            menuname: '折扣设置',
            opens:[],
            path: tms + 'customer_discount_setting',
            icon: 'icon-discount-1'
          }
        ]
      }, {
        menuid: '2-5',
        parentmenuid:'2',
        menuname: '账务中心',
        opens:[],
        icon: 'icon-financial',
        path: '',
        children: [
          {
            menuid: '2-5-1',
            parentmenuid:'2-5',
            menuname: '客户运单核算',
            opens:[],
            path: tms + 'customer_waybill_accounting',
            icon: 'icon-fin-accounting'
          }, {
            menuid: '2-5-2',
            parentmenuid:'2-5',
            menuname: '客户运单出账',
            opens:[],
            path: tms + 'customer_out_bill',
            icon: 'icon-outbilling'
          }, {
            menuid: '2-5-3',
            parentmenuid:'2-5',
            menuname: '客户账单管理',
            opens:[],
            path: tms + 'customer_bill_manage',
            icon: 'icon-billing'
          }, {
            menuid: '2-5-4',
            parentmenuid:'2-5',
            menuname: '供应运单核算',
            icon: 'icon-accounting',
            opens:[],
            path: tms + 'supplier_waybill_accounting'
          }, {
            menuid: '2-5-5',
            parentmenuid:'2-5',
            menuname: '供应运单出账',
            icon: 'icon-outbilling',
            opens:[],
            path: tms + 'supplier_out_bill'
          }, {
            menuid: '2-5-6',
            parentmenuid:'2-5',
            menuname: '供应账单管理',
            icon: 'icon-billing',
            opens:[],
            path: tms + 'supplier_bill_manage'
          }, {
            menuid: '2-5-7',
            parentmenuid:'2-5',
            menuname: '客户费用导入',
            icon: 'icon-import',
            opens:[],
            path: tms + 'customer_fees_import'
          }, {
            menuid: '2-5-8',
            parentmenuid:'2-5',
            menuname: '供应费用导入',
            opens:[],
            path: tms + 'supplier_fees_import',
            icon: 'icon-import'
          }
        ]
      },
      {
        menuid: '2-7',
        parentmenuid:'2',
        menuname: '店铺管理',
        icon: 'icon-store',
        opens:[],
        path: '',
        children: [
          {
            menuid: '2-7-1',
            parentmenuid:'2-7',
            menuname: '店铺设置',
            icon: 'icon-storeset',
            opens:[],
            path: tms + 'store_setting'
          }
        ]
      }
    ]
  }, {
    menuid: '3',
    parentmenuid:'0',
    menuname: '账户中心',
    path: '',
    opens:[],
    icon:'',
    children: [
      {
        menuid: '3-1',
        parentmenuid:'3',
        menuname: '企业管理',
        icon: 'icon-enterprise',
        opens:[],
        path: '',
        children: [
          {
            menuid: '3-1-1',
            parentmenuid:'3-1',
            menuname: '企业设置',
            icon: 'icon-enterprise',
            opens:[],
            path: ems + 'ent_setting'
          }, {
            menuid: '3-1-2',
            parentmenuid:'3-1',
            menuname: '网点管理',
            icon: 'icon-branches',
            opens:[],
            path: ems + 'branches_manage'
          }, {
            menuid: '3-1-3',
            parentmenuid:'3-1',
            menuname: '部门管理',
            icon: 'icon-department',
            opens:[],
            path: ems + 'dep_manage'
          }, {
            menuid: '3-1-4',
            parentmenuid:'3-1',
            menuname: '职位管理',
            icon: 'icon-department',
            opens:[],
            path: ems + 'position_manage'
          }, {
            menuid: '3-1-5',
            parentmenuid:'3-1',
            menuname: '账号管理',
            icon: 'icon-accountm',
            opens:[],
            path: ems + 'account_manage'
          }
        ]
      }, {
        menuid: '3-2',
        parentmenuid:'3',
        menuname: '账户管理',
        icon: 'icon-accountm',
        opens:[],
        path: '',
        children: [
          {
            menuid: '3-2-1',
            parentmenuid:'3-2',
            menuname: '个人信息',
            path: ems + 'personal_info',
            opens:[],
            icon: 'icon-information'
          }, {
            menuid: '3-2-2',
            parentmenuid:'3-2',
            menuname: '安全信息',
            icon: 'icon-safe',
            opens:[],
            path: ems + 'safe_info'
          }
        ]
      }
    ]
  }
]

export default {
  menus: menus
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/common/menu.vue